//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateScript from '../../../../components/date/index.js';
import TextField from '../textField/index.vue';
import DatePicker from '../datePicker/index.vue';
import DatePickerMobile from '../datePicker/mobile.vue';
import ScrollArea from '../scrollArea/index.vue';
import Menu from '../menu/index.vue';
import x24iccalendar from '../../../../iconsPublicSite/icons/x24iccalendar/x24iccalendar';
export default {
  components: {
    TextField,
    DatePicker,
    DatePickerMobile,
    Menu,
    ScrollArea,
    x24iccalendar,
  },
  extends: DateScript,
};
